'use client';

import { c as _c } from "react/compiler-runtime";
import { Loader2, RefreshCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
type WikiRetryButtonProps = {
  onRetry: () => void;
  isRetrying?: boolean;
  variant?: 'default' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  label?: string;
  showIcon?: boolean;
  className?: string;
};
export function WikiRetryButton(t0) {
  const $ = _c(15);
  const {
    onRetry,
    isRetrying: t1,
    variant: t2,
    size: t3,
    label,
    showIcon: t4,
    className
  } = t0;
  const isRetrying = t1 === undefined ? false : t1;
  const variant = t2 === undefined ? "default" : t2;
  const size = t3 === undefined ? "sm" : t3;
  const showIcon = t4 === undefined ? true : t4;
  let t5;
  if ($[0] !== isRetrying || $[1] !== label || $[2] !== size) {
    t5 = () => {
      if (label) {
        return label;
      }
      if (isRetrying) {
        return "Retrying...";
      }
      return size === "sm" ? "Retry generation" : "Try again";
    };
    $[0] = isRetrying;
    $[1] = label;
    $[2] = size;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const getLabel = t5;
  let t6;
  if ($[4] !== getLabel || $[5] !== isRetrying || $[6] !== showIcon) {
    t6 = isRetrying ? <>{showIcon && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}{getLabel()}</> : <>{showIcon && <RefreshCcw className="mr-2 h-4 w-4" />}{getLabel()}</>;
    $[4] = getLabel;
    $[5] = isRetrying;
    $[6] = showIcon;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== className || $[9] !== isRetrying || $[10] !== onRetry || $[11] !== size || $[12] !== t6 || $[13] !== variant) {
    t7 = <Button type="button" onClick={onRetry} disabled={isRetrying} size={size} variant={variant} className={className}>{t6}</Button>;
    $[8] = className;
    $[9] = isRetrying;
    $[10] = onRetry;
    $[11] = size;
    $[12] = t6;
    $[13] = variant;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}